<template>
  <div class="job-list-page">
      <el-tabs type="border-card" class="vh-140">
        <el-tab-pane label="标准方案">
          <el-table :header-cell-style="{ background: '#eef1f6', color: '#606266' }" :data="standards" border :stripe="true" style="width: 100%">
            <template slot="empty">
              <div class="no-data">暂无数据！</div>
            </template>
            <el-table-column label="序号" align="center" width="60">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="方案名称" width="220"></el-table-column>
            <el-table-column prop="remark" label="描述"></el-table-column>
            <el-table-column label="剩余数量" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.allowance > 0" style="color: rgb(78, 194, 58)">{{scope.row.allowance}} 套</span>
                <span v-else  style="color: red">{{scope.row.allowance}} 套</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="个人方案">
          <el-table :header-cell-style="{ background: '#eef1f6', color: '#606266' }" :data="persons" border :stripe="true"
                    style="width: 100%">
            <template slot="empty">
              <div class="no-data">暂无数据！</div>
            </template>
            <el-table-column label="序号" align="center" width="60">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="方案名称" width="220"></el-table-column>
            <el-table-column prop="remark" label="描述"></el-table-column>
            <el-table-column prop="allowance" label="剩余数量" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.allowance > 0" style="color: rgb(78, 194, 58)">{{scope.row.allowance}} 套</span>
                <span v-else  style="color: red">{{scope.row.allowance}} 套</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
  import {fetchData} from "@api/evaluation/scheme";
  import PageBar from "@components/PageBar";
  import {handleConfirm} from '@utils/confirm'
  import sessionStorage from '@utils/store/sessionStorage'
  import {parseTime} from '@/utils/index'
  import {mapGetters} from "vuex";

  export default {
    name: '',
    data() {
      return {
        addDrawer: false,
        drawerVisible: false,
        isEdit: false,
        persons: [],
        standards: [],
        list: [],
        info: {},
        searchParam: {
          studentName: '',
          gradeName: '',
          emergencyDate: ''
        },
      }
    },
    created() {
      this.fetchData()
    },
    computed: {
      ...mapGetters(['user', 'company']),
    },
    methods: {
      formatDate(time) {
        return parseTime(time, "{y}-{m}-{d}")
      },
      fetchData() {
        fetchData(this.company.id).then(resp => {
          let info = resp.data.result || {}
          this.persons = info.persons
          this.standards = info.standards
        })
      },
      toAdd() {
        this.info = {
          emergencyDate: new Date()
        }
        this.addDrawer = true;
      },
      save() {
        let that = this
        this.$refs['record-form'].validate(valid => {
          if (valid) {
            that.dialogVisible = false
            if (this.isEdit) {
              update(this.info).then(resp => {
                that.submitCallback(resp)
              })
            } else {
              this.info.masterId = this.user_info.id
              this.info.masterName = this.user_info.trueName
              save(this.info).then(resp => {
                that.submitCallback(resp)
              })
            }
          }
        })
      },
      toEdit(val) {
        this.isEdit = true
        this.addDrawer = true

        get(val).then(resp => {
          this.info = resp.data.result
        })
      },
      submitCallback(resp) {
        if (resp.status === 200) {
          this.info = {}
          this.$message.success(resp.data.message);
          this.fetchData()
        }
      },
      doRemove(val) {
        handleConfirm('此操作将永久删除, 是否继续?').then(() => {
          remove(val).then(resp => {
            this.$message.success(resp.data.message)
            this.fetchData()
          })
        }).catch(() => {
        })
      },
      close() {
        this.dialogVisible = false
        this.info = {emergencyDate: new Date()}
      },
      toDetail(info) {
        this.info = info
        this.drawerVisible = true
      },
      doSearch() {
        let param = {...this.searchParam}
        sessionStorage.set("emergency-list-search", param)
        this.page.pageNo = 1
        this.fetchData();
      },
      doReset() {
        this.searchParam.studentName = ''
        this.searchParam.gradeName = ''
        this.searchParam.emergencyDate = ''
        sessionStorage.remove("emergency-list-search")
      },
    }
  }
</script>

<style lang="scss">
  .job-list-page {
    .el-select, .el-input, .el-autocomplete {
      width: 100%;
    }
  }
</style>
